<template>
  <div class="c-post-btn">
    <v-btn
      :loading="loading"
      :disabled="isGuest || disabled"
      class="c-confirm-btn"
      :class="disabled ? 'elevation-1' :  'elevation-6'"
      @click="onClicked"
      color="clr-btn" round dark depressed>
      <v-icon left v-if="icon">{{icon}}</v-icon>{{title}}</span>
    </v-btn>
  </div>
</template>

<script>
  import {COMMIN} from "../../constant";
  import UTILS from "../../utils/utils";
  import {answerPostNews} from "../../api/post";

  export default {
    props: {
      initPost: {type:Object, required: true},
      disabled: {type:Boolean, required: true},
      title: {type:String, required: false, default: $T('post.btn.confirm')},
      icon: {type:String, required: false, default: null},
    },
    data: function() {
      return {
        post: this.initPost,
        loading: false,
      };
    },
    watch: {
      initPost(n, o) {
        this.post = n;
        this.loading = false;
      },
    },
    methods: {
      startLoading() {
        this.loading = true;
      },
      stopLoading() {
        this.loading = false;
      },
      onClicked() {
        this.$emit('click');
      }
    },
  }
</script>

<style scoped>
  .c-post-btn {
    position: absolute;
    bottom: 136px;
    left: 50% !important;
    transform: translateX(-50%) !important;
  }
  .le-tbs .c-post-btn {
    position: fixed;
    bottom: 190px;
    left: 50% !important;
    transform: translateX(-50%) !important;
  }
  .c-confirm-btn {
    min-width: 200px;
  }
</style>